module.exports = __webpack_public_path__ + "img/illustration-reset-password-light.5ffc7602.png";